import { EventType, IEvent, IHasEventHandlers, EventHandlers, BubbleDestroyReason } from 'js/bubbleCore/events';
import { game } from 'js/main';
import { Place } from 'js/bubbleCore/types';

export class BoardSounds implements IHasEventHandlers {
  public readonly eventHandlers: EventHandlers = {
    [EventType.BubbleSpaceLimitCollision]: () => {
      // game.sounds.play("bubble_hits_wall");
    },
    [EventType.BubbleTransfered]: (event) => {
      const { fromPlace, toPlace } = event.data;
      if (toPlace === Place.ShootingSpace) {
        game.sounds.play('shoot_bubble');
      }

      if (toPlace === Place.PopOutSpace) {
        game.sounds.play('bubble_pops_1');
      }
    },
    [EventType.BubbleBouncerCollision]: (event) => {
      game.sounds.play('bubble_hits_wall');
    },
    [EventType.BubbleDestroyed]: (event) => {
      if (event.data.reason === BubbleDestroyReason.PointZone) {
        game.sounds.play('bubble_pops_2'); 
      }
    },
    [EventType.ShootingSpaceGridCollision]: (event) => {
      game.sounds.play('bubble_hits_bubble'); 
    },
    [EventType.DeathLineCrossed]: () => {
      game.sounds.play('lost');
    },
    [EventType.ChainChanged]: (event) => {
      if (event.data.bonusGranted) game.sounds.play("won");
    }
  }
}